<script lang="ts">
	import FontSpan from '../typography/FontSpan.svelte';

	export let balance: string | undefined = undefined;
</script>

<div class="flex flex-col gap-2 nft-card">
	<FontSpan varient="body-R-05" class="text-gray-40">Number of NFTs</FontSpan>
	<div class="flex flex-row-reverse items-baseline gap-2 self-stretch">
		<FontSpan varient="body-R-05" class="text-gray-50">Tanks</FontSpan>
		<FontSpan varient="body-B-02" class="text-white">
			{typeof balance === 'number' ? balance : '##'}
		</FontSpan>
	</div>
</div>

<style>
	.nft-card {
		width: 280px;
		padding: 32px 24px;
		justify-content: center;
		align-items: flex-start;

		border-radius: 12px;
		border: 2px solid var(--popup-border, #2d2d2d);
		background: linear-gradient(135deg, rgba(57, 57, 57, 0.7) 0%, rgba(40, 40, 40, 0.7) 100%);

		/* black_shadow */
		box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.2);
	}
</style>
